export default __webpack_public_path__ + "static/media/ek-main-aur-ek-tu.d158d3c2.jpg";